import { BillDto } from 'ts-types/api.types';
import { BillStatus, BillType } from 'ts-types/api.enums';
import React from 'react';
import BillIcons from 'components/layout/BillIcons';

const green = '#44A871';
const red = '#A24049';

export interface BillIconRequest {
  hasReminders: boolean,
  status: BillStatus,
  type: BillType,
  cashBill: boolean
}

const getIconArrayByBillType = (billType: BillType, cashBill: boolean) => {
  if (billType == BillType.COLLECTIVE) {
    return [
      {
        iconName: 'copy outline',
        popUpText: 'bill.type.collective'
      }
    ]
  } else if (billType == BillType.PART_OF_COLLECTIVE) {
    return [
      {
        iconName: 'copy',
        popUpText: 'bill.type.partOfCollective'
      }
    ]
  } else if (cashBill) {
    return [
      {
        iconName: 'money bill alternate outline',
        popUpText: 'bill.cash'
      }
    ]
  } else {
    return [
      {
        iconName: 'file alternate outline',
        popUpText: 'bill.type.normal'
      }
    ];
  }
};

export const getBillIcon = (bill: BillDto | BillIconRequest) => {

  const { hasReminders, status: billStatus, type: billType = BillType.NORMAL, cashBill } = bill;

  let iconArray: Array<any> = [{
    iconName: 'file alternate outline',
    popUpText: 'bill.type.normal'
  }];

  if (billStatus != null) {
    if (billStatus == BillStatus.PAID_CLOSED) {
      iconArray = getIconArrayByBillType((billType as BillType), cashBill);

      iconArray.push({
        iconName: 'check',
        popUpText: 'bill.status.paidClosed',
        color: green
      });

    } else if (billStatus == BillStatus.PAID_OPEN) {

      iconArray = [
        {
          iconName: 'file alternate outline',
          popUpText: 'bill.type.normal'
        }
      ];

      if (billType == BillType.COLLECTIVE) {
        iconArray = [
          {
            iconName: 'copy outline',
            popUpText: 'bill.type.collective'
          }
        ]
      } else if (billType == BillType.PART_OF_COLLECTIVE) {
        iconArray = [
          {
            iconName: 'copy',
            popUpText: 'bill.type.partOfCollective'
          }
        ]
      }

      iconArray.push({
        iconName: 'check',
        popUpText: 'bill.status.paidOpen',
        iconSize: billType == BillType.PART_OF_COLLECTIVE ? 'tiny' : undefined,
        color: green
      });

    } else if (billStatus == BillStatus.STORNO) {
      iconArray = getIconArrayByBillType((billType as BillType), cashBill);

      iconArray.push({
        iconName: 'x',
        popUpText: 'bill.status.storno',
        color: red
      });

    } else if (billStatus == BillStatus.BILL) {
      if (billType == BillType.COLLECTIVE) {
        iconArray = [
          {
            iconName: 'copy outline',
            popUpText: 'bill.type.collective'
          }
        ];

        if (hasReminders) {
          iconArray = [
            {
              iconName: 'copy outline',
              popUpText: 'bill.type.collective'
            },
            {
              iconName: 'warning',
              popUpText: 'bill.hasReminders',
              color: red
            }
          ]
        }
      } else if (billType == BillType.PART_OF_COLLECTIVE) {
        iconArray = [
          {
            iconName: 'copy',
            popUpText: 'bill.type.partOfCollective'
          }
        ];

        if (hasReminders) {
          iconArray = [
            {
              iconName: 'copy',
              popUpText: 'bill.type.partOfCollective'
            },
            {
              iconName: 'warning',
              popUpText: 'bill.hasReminders',
              color: red
            }
          ]
        }
      } else {
        iconArray = [
          {
            iconName: 'file alternate outline',
            popUpText: 'bill.type.normal'
          },
          {
            iconName: 'print',
            popUpText: 'bill.printed'
          }
        ];

        if (hasReminders) {
          iconArray = [
            {
              iconName: 'file alternate outline',
              popUpText: 'bill.type.normal'
            },
            {
              iconName: 'warning',
              popUpText: 'bill.hasReminders',
              color: red
            }
          ]
        } else if (cashBill) {
          iconArray = [
            {
              iconName: 'money bill alternate outline',
              popUpText: 'bill.cash'
            }
          ]
        }
      }
    }
  }

  return <BillIcons icons={iconArray} />
};
